/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_SexualInputs */

const en_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexual Situations`)
};

const fr_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situations sexuelles`)
};

const de_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexuelle Situationen`)
};

const it_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situazioni sessuali`)
};

const ru_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сексуальные ситуации`)
};

const es_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situaciones sexuales`)
};

const zh_cn2_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性爱场景`)
};

const ja_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性的状況`)
};

const hi_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यौन स्थितियाँ`)
};

const pt_pt2_subtitle_export_vchip_sexual = /** @type {(inputs: Subtitle_Export_Vchip_SexualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situações Sexuais`)
};

/**
* | output |
* | --- |
* | "Sexual Situations" |
*
* @param {Subtitle_Export_Vchip_SexualInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_sexual = /** @type {((inputs?: Subtitle_Export_Vchip_SexualInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_SexualInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_sexual(inputs)
	if (locale === "de") return de_subtitle_export_vchip_sexual(inputs)
	if (locale === "it") return it_subtitle_export_vchip_sexual(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_sexual(inputs)
	if (locale === "es") return es_subtitle_export_vchip_sexual(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_sexual(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_sexual(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_sexual(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_sexual(inputs)
	return en_subtitle_export_vchip_sexual(inputs)
});